import React from 'react'
import '../assets/css/Home.styl'
function Home() {
        return (
            <div className="home">
               <div className="banner">

               </div>
               <div className="icon-box">
               <div className="about-title fs-36 mt-36 bold">
                        <div className="tit">
                            产品
                        </div>
                    </div>
                <ul className="flex-justify-center">
                    <li className="icon-item">  
                        <div className="flex-column flex-items-center">
                            <img src={require("../assets/images/logo1.png")} alt="" width="118" height="118"/>
                            <div className="fs-24 mt-24">
                            海豚WiFi管家
                            </div>
                            <div className="fs-16 fc-w6  mt-16">
                            贴身守护您的WiFi安全
                            </div>
                        </div>
                    </li>
                    <li className="icon-item">
                        <div className="flex-column flex-items-center">
                            <img src={require("../assets/images/logo2.png")} alt="" width="118" height="118"/>
                            <div className="fs-24 mt-24">
                            全速手机卫士
                            </div>
                            <div className="fs-16 fc-w6  mt-16">
                            你身边的超强手机管家
                            </div>
                        </div>
                    </li>
                    <li className="icon-item">
                        <div className="flex-column flex-items-center">
                            <img src={require("../assets/images/logo3.png")} alt="" width="118" height="118"/>
                            <div className="fs-24 mt-24">
                            WiFi畅联精灵
                            </div>
                            <div className="fs-16 fc-w6  mt-16">
                            一键畅联 伴您遨游网络世界
                            </div>
                        </div>
                    </li>  
                    <li className="icon-item">
                        <div className="flex-column flex-items-center">
                            <img src={require("../assets/images/logo4.png")} alt="" width="118" height="118"/>
                            <div className="fs-24 mt-24">
                            e键连WiFi
                            </div>
                            <div className="fs-16 fc-w6  mt-16">
                            一键连接 畅快体验
                            </div>
                        </div>
                    </li>               
                </ul>
               </div>
            </div>
        );
    }
export default Home;